module.exports = __webpack_public_path__ + "d639795700ca3aba12bdc6e73a9cb7f0.svg";